import { Helmet } from 'react-helmet';
import NewdanhmucchiphiphatsinhDetail
  from 'src/components/newdanhmucchiphiphatsinh-detail/NewdanhmucchiphiphatsinhDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucchiphiphatsinhListToolbar from '../components/newdanhmucchiphiphatsinh-detail/NewdanhmucchiphiphatsinhToolbar';

const Newdanhmucchiphiphatsinh = () => (
  <>
    <Helmet>
      <title>Danh mục chi phí phát sinh</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucchiphiphatsinhListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucchiphiphatsinhDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucchiphiphatsinh;
